<ng-template #productBodyTemplate>
  <lib-product-box-header [product]="product()" [lightMode]="lightMode()" [isNavProduct]="isNavProduct()" />
  <lib-product-box-description [product]="product()" [lightMode]="lightMode()" />
</ng-template>

@if (product()) {
  <lib-product-card [isOfferBox]="false" class="block pt-10 h-full" [cssClass]="cssClass()">
    <div
      class="product text-center h-full flex flex-col border border-solid border-[--color-gray-3] rounded-[--border-radius-product-boxes]"
      [ngClass]="{
        'shadow-[0_4px_4px_rgba(0,0,0,0.15)]': !lightMode(),
        'shadow-[0_1px_2px_0_rgba(231,231,231,0.7)]': lightMode(),
      }"
      data-testid="product-box"
    >
      <div class="h-12">
        @if (promotion() && hasDiscountedCost() && !lightMode()) {
          <lib-promotion-banner [countdownDate]="countdownDate()" [text]="promotionBannerText()" />
        }
      </div>
      @if (!lightMode()) {
        <lib-link
          [attr.data-testid]="'product-' + product().product_code | lowercase"
          [link]="ctaLink()"
          [queryParams]="queryParams()"
          [queryParamsHandling]="'merge'"
          (onClick)="onProductBoxClick()"
          class="flex-auto flex flex-col [&>a]:flex-auto [&>a]:flex [&>a]:flex-col [&>a>span]:flex-auto"
        >
          <div class="flex flex-col h-full">
            <ng-container *ngTemplateOutlet="productBodyTemplate"></ng-container>
          </div>
        </lib-link>
      } @else {
        <ng-container *ngTemplateOutlet="productBodyTemplate"></ng-container>
      }
      <div class="flex justify-center mb-4">
        <lib-product-box-cta
          class="w-full"
          [ctaLink]="ctaLink()"
          [queryParams]="queryParams()"
          [ctaLabel]="ctaLabel()"
          [ctaClasses]="ctaClasses()"
          (ctaClick)="onProductBoxClick()"
        >
          <lib-product-box-pricing
            [product]="product()"
            [promotion]="promotion()"
            [lightMode]="lightMode()"
            [isNavProduct]="isNavProduct()"
            [discountedPrice]="discountedPrice()"
            [discountPercentage]="discountPercentage()"
            [chipLabels]="chipsLabelsKeys()"
          />
        </lib-product-box-cta>
      </div>

      @if (!lightMode()) {
        <lib-product-box-footer
          [showLearnMore]="showLearnMore()"
          [productCode]="product().product_code"
          [productDetailsLink]="productDetailsLink()"
          [activationFee]="activationFee()"
          [contractDuration]="contractDuration()"
        />
      }
    </div>
  </lib-product-card>
}
